import React from 'react';
import { AgentStatusWrapper, Dot, StatusTag, TypingIndicatorWrapper } from './styled';
import { useAtomValue } from 'jotai';
import { agentStatusMessageDerivedAtom, chatStreamLoadingAtom } from '../NexaStore';

const TypingIndicator = () => {
  const isLoading = useAtomValue(chatStreamLoadingAtom);
  const statusMessage = useAtomValue(agentStatusMessageDerivedAtom) || '⚙️ Working...';

  return isLoading ? (
    <AgentStatusWrapper>
      <StatusTag>
        <div>{statusMessage}</div>
        <TypingIndicatorWrapper>
          <Dot>.</Dot>
          <Dot>.</Dot>
          <Dot>.</Dot>
        </TypingIndicatorWrapper>
      </StatusTag>
    </AgentStatusWrapper>
  ) : null;
};

export default TypingIndicator;
